import { Divider, Grid } from '@mui/material';
import React from 'react'
import { DataTable } from '../../../../Component/Common/Components/DataTable/DataTable';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';
import { Support } from '../../../../Component/Model/Dto/Support/SupportRequest';
import { IBulkActions } from '../../../../Component/Model/Table/Table';
import { SupportFeedbackModal } from './SupportFeedbackModal';
import { TicketFeedbackTableMapper } from './SupportFeedbackTableColumn';

interface IProps {
    allowEdit: boolean;
    data: Support.TicketFeedbackDtoOut[];
    scorecardId: string;
    supportTicketId: string;
    refreshData: () => void;
}

export const SupportFeedbackTable = (props: IProps) => {
    const [entriesPerPage, setEntriesPerPage] = React.useState(10);
    const [pageNumber, setPageNumber] = React.useState<number>(1);

    const [showFeedbackModal, setShowFeedbackModal] = React.useState(false);
    const [selectedFeedbackId, setSelectedFeedbackId] = React.useState<number | undefined>(undefined);

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage(entriesPerPage);
        setPageNumber(1);
    }

    const onViewFeedbackItem = (id: number) => {
        setSelectedFeedbackId(id);
        setShowFeedbackModal(true);
    }

    const captureNewFeedbackTicket = () => {
        setShowFeedbackModal(true);
    }

    const closeFeedbackModal = () => {
        setShowFeedbackModal(false);
        setSelectedFeedbackId(undefined);
        props.refreshData();
    }

    const bulkActions: IBulkActions[] = [
        {
            label: 'Capture New Feedback Ticket',
            action: captureNewFeedbackTicket
        }
    ]

    const indexOfLastPage = pageNumber * entriesPerPage;
    const indexOfFirstPage = indexOfLastPage - entriesPerPage;
    const itemCount = props.data.length;

    const currentData = props.data.slice(
        indexOfFirstPage,
        indexOfLastPage
    );

    const supportFeedbackTableData = TicketFeedbackTableMapper(currentData, onViewFeedbackItem);

    return (
        <>
            <Grid container spacing={1} mt={1}>
                <Grid item xs={12}>
                    <MDTypography variant='h5'>
                        Feedback
                    </MDTypography>
                    <Divider sx={{ mt: 0, mb: 0 }} />
                </Grid>
                <Grid item xs={12}>
                    <DataTable
                        key={pageNumber}
                        bulkActions={props.allowEdit ? bulkActions : []}
                        table={supportFeedbackTableData}
                        entriesPerPage={{ defaultValue: entriesPerPage }}
                        pageNumber={pageNumber}
                        filteredItemsCount={itemCount}
                        totalItemsCount={itemCount}
                        entriesPerPageChanged={entriesPerPageChanged}
                        pageNumberChanged={pageNumberChanged}
                    />
                </Grid>
            </Grid>
            {showFeedbackModal &&
                <SupportFeedbackModal
                    supportFeedbackId={selectedFeedbackId}
                    allowEdit={props.allowEdit}
                    handleClose={closeFeedbackModal}
                    openModal={showFeedbackModal}
                    scorecardId={props.scorecardId}
                    setSupportFeedbackId={setSelectedFeedbackId}
                    supportTicketId={props.supportTicketId}
                />
            }
        </>
    )
}
